import(/* webpackMode: "eager", webpackExports: ["Grant"] */ "/vercel/path0/modules/grant/Grant.tsx");
